import {
  HookFormSelect,
  SubmitButton,
  TextArea,
  TextInput,
} from "../../../hook-form";
import { SectionHeader, SwitchAppButton } from "../../../components";
import { IOnboardingStep2ViewProps } from "./OnboardingStep2";
import { industries } from "../../../constants";

export const View = ({
  isActive,
  errors: errors,
  handlePrevious,
  handleSubmit: handleSubmit,
  register: register,

  isLoadingRevenueBrackets,
  revenueBrackets,
}: IOnboardingStep2ViewProps) => {
  return (
    <form onSubmit={handleSubmit}>
      <div className="onboarding-section">
        <SectionHeader
          title="We would like to know more about your business."
          subtitle="SwitchApp collects this information to verify your identity and keep your account safe."
        />
        <h5 className="form-section--title font-ctm--bold">Business Details</h5>
        <TextInput
          name="registered_business_name"
          label="Registered Business Name"
          infoIconText="The name of the business as it appears in the registration certificate"
          type="text"
          register={register}
          errors={errors}
          disabled={!isActive}
        />
        <TextInput
          name="business_address_line1"
          label="Business Address Line 1"
          type="text"
          register={register}
          errors={errors}
          disabled={!isActive}
        />
        <TextInput
          name="business_address_line2"
          label="Business Address Line 2 (Optional)"
          type="text"
          register={register}
          errors={errors}
          disabled={!isActive}
        />
        <HookFormSelect
          name="industry"
          label="Industry"
          infoIconText="The industry the business is involved in. Select the most fitting if you fall in more than one category."
          showSkeleton={isLoadingRevenueBrackets}
          selectItems={industries.map((ind) => ({
            text: ind.key,
            value: ind.value,
          }))}
          register={register}
          errors={errors}
          disabled={!isActive}
        />
        <TextInput
          name="business_email_address"
          label="Business Email Address"
          infoIconText="Email address that can be used to reach the business directly."
          type="text"
          register={register}
          errors={errors}
          disabled={!isActive}
        />
        <TextInput
          name="business_website"
          label="Business Website (Optional)"
          type="text"
          register={register}
          errors={errors}
          disabled={!isActive}
        />
        {/* <TextInput
          name="business_terms_and_conditions_url"
          label="Terms & Conditions Url"
          type="text"
          register={register}
          errors={errors}
          disabled={!isActive}
        />
        <TextInput
          name="business_privacy_url"
          label="Privacy Url"
          type="text"
          register={register}
          errors={errors}
          disabled={!isActive}
        /> */}
        <TextArea
          name="business_description"
          label="Business Description (Optional)"
          infoIconText="A small description that your customers will see about you."
          cols="70"
          register={register}
          errors={errors}
          disabled={!isActive}
        />

        <HookFormSelect
          name="estimated_monthly_sale_id"
          label="Estimated Monthly Sales (NGN)"
          infoIconText="This will help us better recommend services to you and inform you if you need to upgrade to different tiers to avoid service disruption."
          showSkeleton={isLoadingRevenueBrackets}
          selectItems={
            revenueBrackets.map((revenueBracket) => ({
              text: revenueBracket.revenue_bracket_name,
              value: revenueBracket.id,
            })) || []
          }
          register={register}
          errors={errors}
          disabled={!isActive}
        />

        <div className="flex-container buttons-container">
          {!isActive ? null : (
            <SwitchAppButton
              className="switchapp-themed onboarding-previous--button"
              kind="secondary"
              onClick={handlePrevious}
            >
              Previous
            </SwitchAppButton>
          )}

          {!isActive ? null : (
            <SubmitButton className="switchapp-themed onboarding-submit--button">
              Continue
            </SubmitButton>
          )}
        </div>
      </div>
    </form>
  );
};
